import ScrollReveal from "./ScrollReveal";
import { Award, Wrench, Heart } from "lucide-react";

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="py-24 lg:py-36 bg-[#0284FC]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <ScrollReveal>
            <div className="relative">
              <div
                data-testid="artisan-photo"
                className="w-full aspect-[4/5] rounded-3xl overflow-hidden bg-white/10 backdrop-blur-sm border border-white/15"
              >
                <img
                  src="/images/moi.png"
                  alt="Artisan Vinylux"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="absolute -bottom-4 -right-4 sm:bottom-6 sm:-right-6 bg-white rounded-2xl shadow-lg p-4 sm:p-5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#0284FC]/10 flex items-center justify-center">
                    <Award className="w-5 h-5 text-[#0284FC]" />
                  </div>
                  <div>
                    <div className="font-heading font-bold text-[#0284FC] text-sm">
                      Menuisier de métier
                    </div>
                    <div className="text-[#0284FC]/50 text-xs">
                      Spécialiste finitions
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 bg-white/15 text-white px-4 py-1.5 rounded-full text-sm font-semibold backdrop-blur-sm">
                L&apos;artisan
              </div>

              <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
                Qui est derrière Vinylux ?
              </h2>

              <p className="text-base sm:text-lg text-white/70 leading-relaxed">
                Je suis menuisier de métier, spécialisé dans la rénovation et les finitions.
              </p>

              <p className="text-base sm:text-lg text-white/70 leading-relaxed">
                Avec Vinylux, j&apos;aide mes clients à moderniser leur cuisine sans les contraintes d&apos;un chantier lourd.
              </p>

              <p className="text-base sm:text-lg text-white font-semibold leading-relaxed">
                Mon objectif : un rendu propre, durable et haut de gamme.
              </p>

              <div className="flex flex-wrap gap-3 pt-2">
                {[
                  { icon: Wrench, text: "Menuisier qualifié" },
                  { icon: Award, text: "Matériaux pro" },
                  { icon: Heart, text: "Satisfaction client" },
                ].map((item) => (
                  <div
                    key={item.text}
                    className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 border border-white/15 text-sm text-white/80 font-medium"
                  >
                    <item.icon className="w-4 h-4 text-white" />
                    {item.text}
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}